export default __webpack_public_path__ + "static/media/cowHornChair.6b5d08d8.svg";